import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { PeoplePicker } from "@microsoft/mgt-react";
import CloseIcon from "@mui/icons-material/Close";

const ShareDialog = ({ isOpen, onClose, children, handleShare }) => {
  const [emails, setEmails] = useState([]);

  const handleSelectionChange = (e) => {
    const selectedEmails = e.detail?.map((item) => item.userPrincipalName);
    setEmails(selectedEmails);
  };

  const isSubmitDisabled = emails?.length === 0;

  const Submit = () => {
    handleShare({ GroupId: children, userId: emails });
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        {/* Header */}
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" fontWeight={500}>
            Share 'Digital Conflict Of Interest'
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box mt={2}>
          <PeoplePicker
            selectionChanged={handleSelectionChange}
            sx={{ minHeight: "40px", width: "100%" }}
            placeholder={
              emails?.length > 0 ? "" : "Enter Name or Email Addresses"
            }
          />
        </Box>
      </DialogContent>

      {/* Actions */}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          disabled={isSubmitDisabled}
          onClick={Submit}
          sx={{
            padding: "10px",
            backgroundColor: isSubmitDisabled ? "lightGray" : " #212129",
            color: "white",
            borderRadius: "20px",
            "&:hover": {
              backgroundColor: isSubmitDisabled ? "lightGray" : "darkgray",
            },
          }}
        >
          Add
        </Button>

        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            padding: "10px",
            border: "1px solid  #212129",
            color: " #212129",
            backgroundColor: "white",
            borderRadius: "20px",
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareDialog;
